/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FormativeAction from './FormativeAction';

/**
 * The ArrayOfFormativeActionsWithParent model module.
 * @module model/ArrayOfFormativeActionsWithParent
 * @version 1.0
 */
class ArrayOfFormativeActionsWithParent {
    /**
     * Constructs a new <code>ArrayOfFormativeActionsWithParent</code>.
     * @alias module:model/ArrayOfFormativeActionsWithParent
     */
    constructor() { 
        
        ArrayOfFormativeActionsWithParent.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArrayOfFormativeActionsWithParent</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArrayOfFormativeActionsWithParent} obj Optional instance to populate.
     * @return {module:model/ArrayOfFormativeActionsWithParent} The populated <code>ArrayOfFormativeActionsWithParent</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArrayOfFormativeActionsWithParent();

            if (data.hasOwnProperty('parent')) {
                obj['parent'] = FormativeAction.constructFromObject(data['parent']);
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [Object]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/FormativeAction} parent
 */
ArrayOfFormativeActionsWithParent.prototype['parent'] = undefined;

/**
 * @member {Array.<Object>} children
 */
ArrayOfFormativeActionsWithParent.prototype['children'] = undefined;






export default ArrayOfFormativeActionsWithParent;

